import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import './styles/index.css';
import './styles/components/_Navbar.module.css';
import Navbar from './components/layout/Navbar';
import Contact from './pages/contact/Contact';
import About from './pages/about/About';
import Projects from './components/portfolio/Projects';
import Home from './pages/home/Home';
import CvWeb from './components/portfolio/cv_web';
import Animacion from './components/animations/Animacion';
// import SkillBar from './components/ui/SkillBar/SkillBar';
import BlogList from './features/blog/pages/BlogList';
// import BlogPost from './features/blog/pages/BlogPost';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import ChatbotButton from './components/ChatBot/ChatBot';
import PostForm from './features/blog/components/PostForm';
import AdminPanel from './components/AdminPanel';
import CatalogGlass from './components/CatalogGlass';

// Same tokens as HomeBoldSunset.jsx, so the shell (bg, admin modal) matches the page design.
const COLORS = {
  bg: '#200A08',
  surface: '#341210',
  ink: '#FBEDE2',
  orange: '#FF7A33',
};

const Layout = ({ children }) => {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isCatalog = location.pathname === '/catalog-glass'; 
  const [showPostForm, setShowPostForm] = useState(false);

  // Cambia esta contraseña por la que quieras
  const ADMIN_PASSWORD = '123';

  const handleAddPostClick = () => {
    const input = prompt('Introduce la contraseña para crear un nuevo post:');
    if (input === ADMIN_PASSWORD) {
      setShowPostForm(true);
    } else if (input !== null) {
      alert('Contraseña incorrecta 🔒');
    }
  };

  return (
    <div style={{ background: COLORS.bg }} className="flex flex-col min-h-screen">
{!isCatalog && <Navbar />}

      {/* Contenido a ancho completo, sin columna lateral que lo comprima */}
      <main className="flex-grow w-full">{children}</main>

      {/* Botón de admin flotante, ya no ocupa espacio de layout */}
      {isHome && (
        <>
          <button
            onClick={handleAddPostClick}
            style={{ background: COLORS.surface, color: COLORS.ink, border: `1px solid ${COLORS.orange}` }}
            className="fixed bottom-24 right-6 z-40 px-4 py-2 rounded-full text-xs uppercase shadow-lg hover:opacity-90"
          >
            + Agregar post
          </button>

          {showPostForm && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
              <div className="bg-gray-100 rounded-lg shadow-lg p-6 w-full max-w-md relative">
                <button
                  onClick={() => setShowPostForm(false)}
                  className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 font-bold"
                >
                  ✖
                </button>
                <PostForm closeModal={() => setShowPostForm(false)} />
              </div>
            </div>
          )}
        </>
      )}

      <WhatsAppButton />
      <ChatbotButton />
    </div>
  );
};

const App = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/BlogList" element={<BlogList />} />
      {/*<Route path="/BlogPost/:id" element={<BlogPost />} />*/}
      <Route path="/cv_web" element={<CvWeb />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/catalog-glass" element={<CatalogGlass />} />
    </Routes>
  </Layout>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
// ... en tu renderizado final:
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);